import TypeCheck from "../../utils/Typecheck";

export interface Group {
    id: string
    title: string
    caption?: {
        title: string
        image?: string
    }
}

export const isGroup = (content: unknown): content is Group => {
    const isCaption = (caption: unknown) => {
        return TypeCheck.isObject(caption)
            && TypeCheck.has(caption, 'title') && TypeCheck.isString(caption.title)
            && TypeCheck.has(caption, 'image', true) ? TypeCheck.isString(caption.image) : true;
    }

    return TypeCheck.isObject(content)
    && TypeCheck.has(content, ['id', 'title'])
    && TypeCheck.isString(content.id)
    && TypeCheck.isString(content.title)
    && TypeCheck.has(content, 'caption', true) ? isCaption(content.caption) : true
}
